import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center mb-3"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "container mt-4" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-md-5" }
const _hoisted_6 = { class: "card shadow-sm" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-success alert-dismissible fade show mb-3",
  role: "alert"
}
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger alert-dismissible fade show mb-3",
  role: "alert"
}
const _hoisted_10 = { class: "d-grid" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}

import FormField from '@/components/FormField.vue';
import { useAuthStore } from '@/stores/authStore';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const username = ref('');
const password = ref('');
const logoSrc = require('@/assets/logo.webp');
const router = useRouter();
const route = useRoute();
const showSuccess = ref(false);

// Use storeToRefs to maintain reactivity for store state
const authStore = useAuthStore();
const { error, loading } = storeToRefs(authStore);

const isLoading = computed(() => loading.value);

const clearError = () => {
  error.value = null;
};

const handleLogin = async () => {
  try {
    await authStore.login(username.value, password.value);
    
    if (authStore.loggedIn) {
      // Show success message
      showSuccess.value = true;
      
      // Hide success message after 1.5 seconds
      setTimeout(() => {
        showSuccess.value = false;
        // Redirect after hiding the success message
        const redirectPath = route.query.redirect as string || '/home';
        router.push(redirectPath);
      }, 1500);
    }
  } catch (err) {
    console.error('Login failed:', err);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(authStore).loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(logoSrc),
            alt: "Logo",
            class: "img-fluid",
            style: {"max-width":"200px"}
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-center mb-3 fw-semibold" }, "Login", -1)),
              (showSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Successfully logged in! ")),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showSuccess.value = false)),
                      "aria-label": "Close"
                    })
                  ]))
                : _createCommentVNode("", true),
              (_unref(error))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      onClick: clearError,
                      "aria-label": "Close"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                onSubmit: _withModifiers(handleLogin, ["prevent"])
              }, [
                _createVNode(FormField, {
                  modelValue: username.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event)),
                  id: "username",
                  type: "text",
                  placeholder: "Enter your username",
                  icon: "fas fa-envelope",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(FormField, {
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                  id: "password",
                  type: "password",
                  placeholder: "Enter your password",
                  icon: "fas fa-lock",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary btn-sm mt-2",
                    disabled: isLoading.value
                  }, [
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(isLoading.value ? 'Logging in...' : 'Login'), 1)
                  ], 8, _hoisted_11)
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})